import { Button, type ButtonProps } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

import { useFormContext } from "./form-context";

export type SubmitButtonProps = ButtonProps & {
	label?: string;
	isLoading?: boolean;
	children?: React.ReactNode;
};

export function SubmitButton({
	label,
	isLoading,
	className,
	children,
	...props
}: SubmitButtonProps) {
	const form = useFormContext();

	return (
		<form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
			{([canSubmit, isSubmitting]) => (
				<Button className={className} disabled={!canSubmit} type="submit" {...props}>
					{children || (isSubmitting || isLoading ? <Spinner /> : label)}
				</Button>
			)}
		</form.Subscribe>
	);
}
